var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoexam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 159,
    viewBox: "0 0 160 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.9588 156.896C124.704 155.815 158.479 120.287 157.398 77.542C156.316 34.797 120.788 1.02194 78.0431 2.10321C35.2981 3.18449 1.52303 38.7127 2.60431 81.4577C3.68558 124.203 39.2138 157.978 81.9588 156.896Z",
    fill: "#EAECF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128.396 155.722L35.5201 158.071L32.988 57.9715C37.3654 57.8558 41.5182 56.0085 44.5353 52.8348C47.5524 49.6611 49.1874 45.4202 49.0816 41.0425L108.935 39.5285C108.985 41.6971 109.465 43.8343 110.347 45.8163C111.228 47.7983 112.494 49.5858 114.071 51.0754C115.638 52.5754 117.488 53.7498 119.512 54.5302C121.536 55.3107 123.695 55.6818 125.864 55.6221L128.396 155.722Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7055 107.362C94.3839 107.016 105.192 95.6474 104.846 81.969C104.5 68.2906 93.1309 57.4826 79.4525 57.8286C65.7741 58.1746 54.966 69.5436 55.312 83.222C55.6581 96.9004 67.0271 107.708 80.7055 107.362Z",
    fill: "#98A2B3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1292 94.0495L80.1512 85.5145L71.6163 94.4925L68.6236 91.6475L77.1586 82.6696L68.1806 74.1346L71.0256 71.142L80.0036 79.6769L88.5385 70.699L91.5311 73.544L82.9962 82.5219L91.9741 91.0568L89.1292 94.0495Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2763 113.215L67.4455 113.894C65.7357 113.937 64.3847 115.358 64.4279 117.068C64.4712 118.778 65.8923 120.129 67.6021 120.086L94.4329 119.407C96.1427 119.364 97.4937 117.942 97.4505 116.233C97.4072 114.523 95.9861 113.172 94.2763 113.215Z",
    fill: "#EAECF0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M103.879 125.363L58.4728 126.512C56.763 126.555 55.412 127.976 55.4553 129.686C55.4985 131.396 56.9196 132.747 58.6294 132.704L104.035 131.555C105.745 131.512 107.096 130.091 107.053 128.381C107.01 126.671 105.589 125.32 103.879 125.363Z",
    fill: "#EAECF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoexam);
export default __webpack_public_path__ + "static/media/noexam.2491815d732a1edab01bd900e12a7b65.svg";
export { ForwardRef as ReactComponent };